export const AddCommasToNumber = (x) => {
  x = x.toString();
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(x)) x = x.replace(pattern, '$1,$2');
  return x;
};

export const LoadAPIData = (url, onComplete, onError) => {
  const request = new XMLHttpRequest();
  request.open('GET', url, true);
  request.onload = (e) => {
    const request = e.currentTarget;
    if (request.status >= 200 && request.status < 400) {
      const data = JSON.parse(request.response);
      if (onComplete) onComplete(data.result);
    } else {
      if (onError) onError(e);
    }
  };
  request.send();
};
